import { isFunction } from '@pct-ts/typeguard';
import { I18nProviderInjectionToken } from './i18n/i18n.scope';
import { type DialogMessageOptions, openOKDialog } from '@pct-ng/feature-message-material';
import type { StrictOmit } from '@pct-ts/typing';

export function showUnknownErrorDialog(
  onDialogClosed?: (error: any) => void,
  options?: Partial<StrictOmit<DialogMessageOptions, 'type'>>,
  error: any | undefined | null = undefined,
  errorCode = 'U1000',
): void {
  openOKDialog({
    title: `${I18nProviderInjectionToken.scope}.UNKNOWN.TITLE`,
    message: {
      translate: true,
      text: `${I18nProviderInjectionToken.scope}.UNKNOWN.MESSAGE`,
      translateParams: { errorCode },
    },
    ...(options ?? {}),
  }).subscribe(() => {
    if (isFunction(onDialogClosed)) {
      onDialogClosed(error);
    }
  });
}
